export const TASK_TYPE_MORE_ITEMS_DROPDOWN_STYLES = {
  maxHeight: 290,
  maxWidth: 288,
  minWidth: 288,
}

export const TASK_ACTION_ATTACH_FILE = 'attach_file'

export const TASK_ACTION_MARK_AS_DONE = 'mark_as_done'

export const TASK_ACTION_MARK_AS_OPEN = 'mark_as_open'

export const TASK_ACTION_MARK_AS_SHARED = 'mark_as_shared'

export const TASK_ACTION_MARK_AS_HIDDEN = 'mark_as_hidden'

export const TASK_ACTION_SET_YESNO_STATUS_AS_NO = 'set_yesno_status_as_no'

export const TASK_ACTION_SET_YESNO_STATUS_AS_NULL = 'set_yesno_status_as_null'

export const TASK_ACTION_SET_YESNO_STATUS_AS_YES = 'set_yesno_status_as_yes'

export const TASK_ACTION_SEND_TO_PROVIDER = 'send_to_provider'

export const TASK_ACTION_SEND_TO_DWELLER = 'send_to_dweller'

export const TASK_ACTION_ATTACH_EMAILS = 'attach_emails'

export const TASK_REQUEST_FIELDS = {
  contractors: 'contractors',
  owner: 'owner',
}

export const TASK_ACTION_SEND_AUDIENCE = {
  [TASK_REQUEST_FIELDS.contractors]: 'providers',
  [TASK_REQUEST_FIELDS.owner]: 'dwellers',
}
